import { ManagementPage } from "../components/common/ManagementPage";

const customerFields = [
  { name: "customer_name", label: "Customer name", required: true, placeholder: "Northern Freight" },
  { name: "contact_name", label: "Contact name", required: true, placeholder: "Melissa Grant" },
  { name: "phone", label: "Phone", required: true, placeholder: "403-555-0101" },
  { name: "email", label: "Email", required: true, placeholder: "dispatch@company.com", type: "email" },
  { name: "billing_address", label: "Billing address", required: true, placeholder: "1450 Eastport Rd", type: "textarea" },
  { name: "city", label: "City", required: true, placeholder: "Calgary" },
  { name: "province_or_state", label: "Province / State", required: true, placeholder: "AB" },
  { name: "postal_code", label: "Postal code", required: true, placeholder: "T2E 7Z9" },
  { name: "country", label: "Country", required: true, placeholder: "Canada" },
  {
    name: "default_currency",
    label: "Default currency",
    required: true,
    type: "select",
    options: [
      { label: "CAD", value: "CAD" },
      { label: "USD", value: "USD" },
    ],
  },
  { name: "payment_terms", label: "Payment terms", required: true, placeholder: "Net 30", defaultValue: "Net 30" },
  { name: "notes", label: "Notes", placeholder: "Customer instructions or billing notes", type: "textarea" },
  {
    name: "active_status",
    label: "Active status",
    required: true,
    type: "select",
    defaultValue: "true",
    parse: (value) => value === true || value === "true",
    options: [
      { label: "Active", value: "true" },
      { label: "Inactive", value: "false" },
    ],
  },
];

const formatMoney = (value, currency) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency, maximumFractionDigits: 2 }).format(value || 0);

export const CustomersPage = () => (
  <ManagementPage
    actionLabel="Add customer"
    columns={[
      {
        key: "customer_name",
        label: "Customer",
        render: (item, Link) => (
          <div>
            <Link
              className="text-sm font-semibold text-zinc-900 underline-offset-4 transition hover:text-zinc-600 hover:underline"
              data-testid={`customer-detail-link-${item.id}`}
              to={`/customers/${item.id}`}
            >
              {item.customer_name}
            </Link>
            <p className="mt-1 text-xs text-zinc-500">{item.contact_name}</p>
          </div>
        ),
      },
      { key: "phone", label: "Phone" },
      { key: "email", label: "Email" },
      { key: "city", label: "City" },
      { key: "default_currency", label: "Currency" },
      { key: "load_count", label: "Loads" },
      {
        key: "active_status",
        label: "Status",
        render: (item) => (item.active_status ? "Active" : "Inactive"),
      },
      { key: "cad_revenue", label: "CAD Revenue", render: (item) => formatMoney(item.cad_revenue, "CAD") },
      { key: "usd_revenue", label: "USD Revenue", render: (item) => formatMoney(item.usd_revenue, "USD") },
    ]}
    description="Maintain customer contacts, billing defaults, and a quick view of how much work and revenue each customer is generating."
    endpoint="/customers"
    entityName="Customer"
    fields={customerFields}
    note="Open any customer name to see load history, status breakdown, and customer-specific revenue totals."
    pageTestId="customers-page"
    serverPagination
    title="Customers"
  />
);